export enum Colors {
    RED = "#f73e31",
    BUTTON_GREEN = "rgba(53,89,62,1)",
    LIGHT_LIGHT_GREEN = "rgba(141,227,190,1)",
    LIGHT_GREEN = "rgba(26,42,35,1)",
    DARK_GREEN = "rgba(18,34,27,1)",
    YELLOW = "#fad637",
    BLACK = "#000000",
    WHITE = "#F6F7EB",
}